
(function () {
    'use strict';

    function escapeAttr(value) {
      return CSS.escape ? CSS.escape(value) : value.replace(/[^\w-]/g, function (c) { return '\\' + c; });
    }

    function updateImage(card, colorValue) {
      card.querySelectorAll('.pvs__product-img--color').forEach(function (img) {
        img.classList.toggle(
          'pvs__product-img--active',
          img.dataset.pvsColorImg === colorValue
        );
      });
    }

    function updatePrice(card, colorValue) {
      var priceEl   = card.querySelector('.pvs__price-current');
      var compareEl = card.querySelector('.pvs__price-compare');
      var esc = escapeAttr(colorValue);
      var priceSpan   = card.querySelector('[data-pvs-color-price="' + esc + '"]');
      var compareSpan = card.querySelector('[data-pvs-color-compare="' + esc + '"]');
      if (priceEl && priceSpan) {
        priceEl.textContent = priceSpan.textContent.trim();
      }

      if (compareSpan) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'pvs__price-compare';
          if (priceEl) {
            priceEl.insertAdjacentElement('afterend', compareEl);
          }
        }
        compareEl.textContent = compareSpan.textContent.trim();
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
    }


    function sortColorsByDiscount(sectionEl) {
      sectionEl.querySelectorAll('.pvs__colors.variant-option-wrapper').forEach(function (wrapper) {
        var items = Array.from(wrapper.querySelectorAll('.pvs__color-item[data-pvs-color-value]'));
        if (items.length <= 1) return;

        var colorData = items.map(function (item) {
          var colorValue  = item.dataset.pvsColorValue;
          var esc         = escapeAttr(colorValue);
          var priceSpan   = wrapper.querySelector('[data-pvs-color-price="' + esc + '"]');
          var compareSpan = wrapper.querySelector('[data-pvs-color-compare="' + esc + '"]');
          var rawPrice    = priceSpan ? parseInt(priceSpan.dataset.pvsPriceRaw   || '0', 10) : 0;
          var rawCompare  = priceSpan ? parseInt(priceSpan.dataset.pvsCompareRaw || '0', 10) : 0;
          var discount    = rawCompare > rawPrice ? rawCompare - rawPrice : 0;
          return { item: item, colorValue: colorValue, priceSpan: priceSpan, compareSpan: compareSpan, discount: discount };
        });

        var anyDiscount = colorData.some(function (d) { return d.discount > 0; });
        if (!anyDiscount) return;

        colorData.sort(function (a, b) {
          if (a.discount > 0 && b.discount === 0) return -1;
          if (a.discount === 0 && b.discount > 0) return 1;
          return b.discount - a.discount;
        });

        colorData.forEach(function (d) {
          wrapper.appendChild(d.item);
          if (d.priceSpan)   wrapper.appendChild(d.priceSpan);
          if (d.compareSpan) wrapper.appendChild(d.compareSpan);
        });

        // Update active state to new first item
        var first = colorData[0];
        wrapper.querySelectorAll('.pvs__color-item').forEach(function (ci) {
          ci.classList.toggle('pvs__color-item--active', ci === first.item);
        });
        var radio = first.item.querySelector('.pvs__color-radio');
        if (radio) radio.checked = true;

        // Sync displayed price & image with the new first color
        var card = wrapper.closest('.pvs__card');
        if (card) {
          updateImage(card, first.colorValue);
          updatePrice(card, first.colorValue);
        }
      });
    }

    function initSection(sectionEl) {
      var list = sectionEl.querySelector('.pvs__list');
      if (!list) return;
      list.addEventListener('click', function (e) {
        var item = e.target.closest('.pvs__color-item[data-pvs-color-value]');
        if (!item) return;
        var card = item.closest('.pvs__card');
        if (!card) return;
        var radio = item.querySelector('.pvs__color-radio');
        if (radio && !radio.checked) {
          radio.checked = true;
        }
        card.querySelectorAll('.pvs__color-item').forEach(function (ci) {
          ci.classList.toggle('pvs__color-item--active', ci === item);
        });
        var colorValue = item.dataset.pvsColorValue || '';
        updateImage(card, colorValue);
        updatePrice(card, colorValue);
      });
    }


    function initFadeAnimations(sectionEl) {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      gsap.registerPlugin(ScrollTrigger);

      var cardIdx = 0;
      sectionEl.querySelectorAll('.pvs__card.pvs__fade').forEach(function (card) {
        if (!card.style.getPropertyValue('--pvs-card-i')) {
          card.style.setProperty('--pvs-card-i', cardIdx);
        }
        cardIdx++;
      });
      sectionEl.querySelectorAll('.pvs__fade').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 90%',
          onEnter: function () { el.classList.add('active'); },
          once: true
        });
      });
    }

    function boot() {
      document.querySelectorAll('.pvs').forEach(function (sectionEl) {
        sortColorsByDiscount(sectionEl);
        initSection(sectionEl);
        initFadeAnimations(sectionEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  